import { render, staticRenderFns } from "./ReturnInventoryAccession.vue?vue&type=template&id=b1174934"
import script from "./ReturnInventoryAccession.vue?vue&type=script&lang=js"
export * from "./ReturnInventoryAccession.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports